import { UrlTree } from '@angular/router';
import { UserProfile } from '@lbmx/types';
import { Observable, of } from 'rxjs';
import { routePermissions } from '../../features/secure/main-navigation-container/permissions';

export default function checkAuthorization(
  profile: UserProfile,
  config: { [key: string]: any }
): Observable<boolean | UrlTree> {
  return of(isAuthorized(profile.toolKeys, routePermissions, config.url));
}

const isAuthorized = (
  toolKeys: number[],
  permissionItems: { [key: string]: number | number[] },
  url: string
): boolean => {
  if (toolKeys.length === 0) {
    return false;
  }

  const urlSegment = `/${url.split('/')[1]}`;

  if (
    urlSegment === '/PlaygroundModule' ||
    urlSegment === '/home' ||
    urlSegment === '/default' ||
    urlSegment === '/terms'
  ) {
    return true;
  }

  const routePermission = permissionItems[urlSegment];
  if (routePermission) {
    return Array.isArray(routePermission)
      ? routePermission.find((perm) => toolKeys.includes(perm)) !== undefined
      : toolKeys.includes(routePermission);
  }

  return undefined;
};
